const ACCEPTED_FORMATS = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif']

export const validateImageFile = (file: File): { valid: boolean; error?: string } => {
  if (!ACCEPTED_FORMATS.includes(file.type)) {
    return {
      valid: false,
      error: 'Invalid file type. Please upload a JPG, JPEG, PNG, or GIF image.',
    }
  }
  return { valid: true }
}

export const autoCropImage = (file: File, targetWidth: number, targetHeight: number): Promise<Blob> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = (e) => {
      const img = new Image()

      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        if (!ctx) {
          reject(new Error('Failed to get canvas context'))
          return
        }

        // Only resize if image is larger than target dimensions
        if (img.width <= targetWidth && img.height <= targetHeight) {
          // Image is already small enough, just convert to blob without resizing
          canvas.width = img.width
          canvas.height = img.height
          ctx.drawImage(img, 0, 0)
        } else {
          // Set canvas to target dimensions
          canvas.width = targetWidth
          canvas.height = targetHeight

          // Calculate scaling to cover the target dimensions
          const scale = Math.max(targetWidth / img.width, targetHeight / img.height)

          const scaledWidth = img.width * scale
          const scaledHeight = img.height * scale

          // Center the image
          const x = (targetWidth - scaledWidth) / 2
          const y = (targetHeight - scaledHeight) / 2

          // Draw the scaled and centered image
          ctx.drawImage(img, x, y, scaledWidth, scaledHeight)
        }

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error('Failed to create blob from canvas'))
              return
            }
            resolve(blob)
          },
          'image/jpeg',
          0.95
        )
      }

      img.onerror = () => reject(new Error('Failed to load image'))
      img.src = e.target?.result as string
    }

    reader.onerror = () => reject(new Error('Failed to read file'))
    reader.readAsDataURL(file)
  })
